import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import apiService from 'services/api'

interface RSMOption {
  label: string
  value: number
}

export function useRSMEligibleUsers(
  enabled: boolean,
  excludeUserId?: number | null
) {
  const api = apiService()

  const { data: rsmEligibleUsers } = useQuery({
    queryKey: ['rsm-eligible-users'],
    queryFn: async () => {
      return await api.getRSMEligibleUsers()
    },
    enabled,
  })

  const rsmOptions = useMemo<RSMOption[]>(() => {
    if (!rsmEligibleUsers) return []
    return rsmEligibleUsers
      .filter((u) => u.id !== excludeUserId)
      .map((u) => ({
        label: `${u.first_name} ${u.last_name}`,
        value: u.id,
      }))
  }, [rsmEligibleUsers, excludeUserId])

  return { rsmOptions, rsmEligibleUsers }
}
